var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.31319 10.6849H2.23243L7.89558 5.0137L6.97635 4.09315L1.31319 9.76438V10.6849ZM10.7025 4.06027L7.912 1.29863L8.83123 0.378082C9.08293 0.126027 9.39219 0 9.75901 0C10.1254 0 10.4344 0.126027 10.6861 0.378082L11.6054 1.29863C11.8571 1.55068 11.9884 1.8549 11.9993 2.21129C12.0103 2.56723 11.8899 2.87123 11.6382 3.12329L10.7025 4.06027ZM0.656597 12C0.470561 12 0.314729 11.9369 0.1891 11.8106C0.0630334 11.6848 0 11.5288 0 11.3425V9.48493C0 9.39726 0.016415 9.31244 0.0492448 9.23047C0.0820747 9.14805 0.131319 9.07397 0.196979 9.00822L6.95993 2.23562L9.75047 5.03014L2.98752 11.8027C2.92186 11.8685 2.8481 11.9178 2.76624 11.9507C2.68395 11.9836 2.59903 12 2.51148 12H0.656597ZM7.43596 4.55342L6.97635 4.09315L7.89558 5.0137L7.43596 4.55342Z",
    fill: "#6600C4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.99e318c7148bd080a33e9f04998b5dd2.svg";
export { ForwardRef as ReactComponent };